import { render } from "./GenproxCheckbox.vue?vue&type=template&id=8684fdaa&scoped=true&ts=true"
import script from "./GenproxCheckbox.vue?vue&type=script&lang=ts"
export * from "./GenproxCheckbox.vue?vue&type=script&lang=ts"

import "./GenproxCheckbox.vue?vue&type=style&index=0&id=8684fdaa&lang=postcss&scoped=true"
/* custom blocks */
import block0 from "./GenproxCheckbox.vue?vue&type=custom&index=0&blockType=docs"
if (typeof block0 === 'function') block0(script)


import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8684fdaa"]])

export default __exports__